<template>
  <div class="popoverDiff">
    <div v-for="(item, index) in listData" :key="index">
      <p>Q： {{ item.title }}</p>
      <p>
        <span>A：{{ index ? '' : '实体卡：' }}</span>
        {{ item.label1 }}
      </p>
      <p v-if="item.label2.length">
        <span>{{ 'eSIM卡' }}</span>
        {{ item.label2 }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listData: [
        {
          title: '实体卡和eSIM卡的主要区别是什么？',
          label1: '支持所有手机设备，会有一张实体的手机卡寄送给您。',
          label2: '：支持部分手机设备，没有实体手机卡，激活过程中扫码安装即可使用。'
        }
      ]
    };
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.popoverDiff {
  > div {
    p {
      &:first-child {
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        color: #1d875a;
      }
      font-weight: 500;
      color: #000000;
      span {
        color: #ce8917;
      }
    }
    &:not(:last-child) {
      border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
      padding: 16px 0;
      margin: 0 16px;
    }
    &:last-child {
      padding: 16px 0 0;
      margin: 0 16px;
    }
  }
}
@media (max-width: 767px) {
  .popoverDiff {
    width: 76vw;
    padding: 1vw;
    > div {
      p {
        &:first-child {
          font-weight: 600;
          font-size: 2.9333vw;
          line-height: 5.6vw;
          color: #1d875a;
        }
        font-weight: 500;
        color: rgba(0, 0, 0, 0.65);
        span {
          color: #ce8917;
        }
      }
      &:not(:last-child) {
        border-bottom: 0.1333vw dashed rgba(0, 0, 0, 0.1);
        padding: 0 0 4.2667vw;
        margin: 0 0 4.2667vw;
      }
      &:last-child {
        padding: 2.1333vw 0 0;
        margin: 0 2.1333vw;
      }
    }
  }
}
</style>
